export const MENU_TITLE = 'Дистанционное обучение';
export const MENU_DESCRIPTION =
  'Перейдите в раздел чтобы ознакомиться с доступными вебинарами и уроками';
export const MENU_HEIGHT = '187px';



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/remotemenu/consts.ts